import { DatePickerValue } from '@mantine/dates';
import { dayjs } from '@ui';
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

export type Range = DatePickerValue<'range'>;

export type DateRange = {
  startDate: Date | null;
  endDate: Date | null;
};

export interface DateRangePreset {
  label: string;
  range: DateRange;
}

export const defaultPresets: DateRangePreset[] = [
  {
    label: 'Today',
    range: {
      startDate: dayjs().toDate(),
      endDate: dayjs().toDate()
    }
  },
  {
    label: 'Yesterday',
    range: {
      startDate: dayjs().subtract(1, 'day').toDate(),
      endDate: dayjs().subtract(1, 'day').toDate()
    }
  },
  {
    label: 'This Week',
    range: {
      //using the week day plugin for this. https://day.js.org/docs/en/get-set/weekday
      startDate: dayjs().weekday(0).toDate(),
      endDate: dayjs().weekday(6).toDate()
    }
  },
  {
    label: 'Last Week',
    range: {
      startDate: dayjs().weekday(-7).toDate(),
      endDate: dayjs().weekday(-1).toDate()
    }
  },
  {
    label: 'This Month',
    range: {
      startDate: dayjs().startOf('month').toDate(),
      endDate: dayjs().endOf('month').toDate()
    }
  },
  {
    label: 'Last Month',
    range: {
      startDate: dayjs().subtract(1, 'month').startOf('month').toDate(),
      endDate: dayjs().subtract(1, 'month').endOf('month').toDate()
    }
  }
];
